module.exports = __webpack_public_path__ + "static/media/so.f132fe50.svg";